import { render, staticRenderFns } from "./DealBannerContent.vue?vue&type=template&id=02346b50&scoped=true&"
import script from "./DealBannerContent.vue?vue&type=script&lang=js&"
export * from "./DealBannerContent.vue?vue&type=script&lang=js&"
import style0 from "./DealBannerContent.vue?vue&type=style&index=0&id=02346b50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02346b50",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TooltipIcon: require('/app/appsumo/nuxt/components/common/TooltipIcon.vue').default})
